import "./LikesModal.scss";
import { useEffect, useState } from "react";
import { Avatar, Button, Modal, Spin, Typography } from "antd";
import { LikeFilled, UserOutlined } from "@ant-design/icons";
import { useDispatch } from "react-redux";
import { getCommentLikers } from "../../features/comments/commentsActions";
import defaultImage from "../../assets/default_image_patient.png";

const PER_PAGE = 10;

export default function LikesModal({
  token,
  open,
  onCancel,
  patientId,
  commentId,
  openNotificationWithIcon,
}) {
  const dispatch = useDispatch();
  const [likers, setLikers] = useState([]);
  const [meta, setMeta] = useState(null);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);

  useEffect(() => {
    if (open && patientId && commentId) {
      setLoading(true);
      setLikers([]);
      setMeta(null);
      setPage(1);
      dispatch(
        getCommentLikers({
          patientId,
          commentId,
          page: 1,
          per_page: PER_PAGE,
        })
      )?.then((res) => {
        setLoading(false);
        if (res?.type === "get_comment_likers/fulfilled") {
          setLikers(res?.payload?.results || []);
          setMeta(res?.payload?.meta || null);
        } else if (res?.type === "get_comment_likers/rejected") {
          const error = res?.payload || { Error: "An error occurred" };
          for (let key in error) {
            if (typeof error[key] === "string") {
              openNotificationWithIcon("error", "Error", error[key]);
              break;
            }
          }
        }
      });
    }
  }, [open, patientId, commentId, dispatch, openNotificationWithIcon]);

  const handleLoadMore = () => {
    const nextPage = page + 1;
    setLoading(true);
    dispatch(
      getCommentLikers({
        patientId,
        commentId,
        page: nextPage,
        per_page: PER_PAGE,
      })
    )?.then((res) => {
      setLoading(false);
      if (res?.type === "get_comment_likers/fulfilled") {
        setLikers((prev) => [...prev, ...(res?.payload?.results || [])]);
        setMeta(res?.payload?.meta || null);
        setPage(nextPage);
      } else if (res?.type === "get_comment_likers/rejected") {
        const error = res?.payload || { Error: "An error occurred" };
        for (let key in error) {
          if (typeof error[key] === "string") {
            openNotificationWithIcon("error", "Error", error[key]);
            break;
          }
        }
      }
    });
  };

  return (
    <Modal
      style={{
        borderTop: `2px solid ${token?.colorPrimary}`,
        borderRadius: 8,
        overflow: "hidden",
      }}
      width={450}
      className="likesModal-cont"
      open={open}
      centered={true}
      destroyOnHidden={true}
      onCancel={onCancel}
      footer={
        meta && likers?.length < meta?.count ? (
          <Button
            block
            shape="round"
            loading={loading}
            disabled={loading}
            onClick={handleLoadMore}>
            {`${!loading ? Math.min(PER_PAGE, meta?.count - likers?.length) : ""} More Likes`}
          </Button>
        ) : null
      }
      title={
        <span>
          <LikeFilled style={{ color: token?.colorPrimary, marginRight: 8 }} />
          Likes
        </span>
      }>
      <div className="likesModal-cont__list">
        {likers?.length === 0 && !loading ? (
          <Typography.Text type="secondary">No likes yet</Typography.Text>
        ) : (
          <Spin spinning={loading}>
            <div className="likesModal-cont__list__users">
              {likers.map((user) => (
                <div key={user?.id} className="likesModal-cont__list__user">
                  <Avatar
                    size={36}
                    src={user?.picture_url || defaultImage}
                    icon={<UserOutlined />}
                    style={{
                      border: `1.5px solid ${token?.colorSecondaryLogo}`,
                      flexShrink: 0,
                    }}
                  />
                  <Typography.Text strong>
                    {user?.author_name || ""}
                  </Typography.Text>
                </div>
              ))}
            </div>
          </Spin>
        )}
      </div>
    </Modal>
  );
}
